import { call, put } from 'redux-saga/effects';
import Http from '../../../../../../libs/Http';

export function* addNote(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const data = yield call(Http.post, '/clients/addNote', {
    body: {
      username: payload.username,
      note: payload.note,
    }
  });
  yield put({
    $global: true,
    type: 'FETCH_CLIENT_DATA_AND_TRADES',
    payload: {
      username: payload.username,
    }
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export default function* ({ takeFirst, takeLatest }) {
  yield [
    takeLatest('CLIENT_ADD_NOTE', addNote),
  ];
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/ClientModal/ClientNotes/ClientNotes.sagas.js